import { defineComponent as _defineComponent } from 'vue'
import { FeatureTypes } from '../../Billing/billing-types';
import { WORKFLOW_CAPABILITIES_MAP } from '@/components/dialogs/CouldntDowngradeBillingPlanDialog/capabilities-consts';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoSuitableBillingPlan',
  props: {
    reasons: null
  },
  emits: ["open-upgrade-dialog"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'open-upgrade-dialog'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	reasons: FeatureTypes[];
}





const openUpgradeDialog = () => {
	emit('open-upgrade-dialog');
};

return { __sfc: true,props, emit, openUpgradeDialog, WORKFLOW_CAPABILITIES_MAP }
}

})